

























































import Vue from "vue";
import {Order, Orders} from '../../../ordercall'
import StatusField from './fields/StatusField.vue'
import RegionField from './fields/RegionField.vue'
import CommentField from './fields/CommentField.vue'
import ContactsField from './fields/ContactsField.vue'
import DateField from './fields/DateField.vue'
import ItemsField from './fields/ItemsField.vue'
import UrlField from './fields/UrlField.vue'
import TimeField from './fields/TimeField.vue'
import TopicField from './fields/TopicField.vue'
import CheckboxesField from "./fields/CheckboxesField.vue"
import shopOrdercall from "../../../shop.ordecall"

export default Vue.extend({
  props: ['orders', 'settings'],
  mounted() {

    if (shopOrdercall.uiVersion === '2.0') {
      const main = document.querySelector('main') as HTMLElement;
      if (main) {
        main.style.overflow = 'scroll';
      }
    }
    // Comment modal
    $(document).on('click', function (e) {
      if (!$(e.target).closest(".comment-modal").length && !$(e.target).closest(".show_comment").length) {
        $('.comment-modal').fadeOut(150);
        $('.oc-table').find('tr').removeClass('hover');
      }
    });
  },
  methods: {
    deleteOrder(order: Order) {
      this.$emit('deleteOrder', order)
    },
    setStatus(order: Order, status: number) {
      this.$emit('setStatus', order, status)
    }
  },
  components: {
    CheckboxesField,
    StatusField,
    RegionField,
    CommentField,
    ContactsField,
    DateField,
    ItemsField,
    UrlField,
    TimeField,
    TopicField,
  }
})



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/webpack/vue/backend/components/table/Table.vue